import React from 'react';
import { Button } from '@chakra-ui/react';
import { House, X } from '@phosphor-icons/react';

const InactiveDropPointButton = ({ refetch, dispatch, state }) => {
  const handleShowInactiveDropPoints = async () => {
    // await refetch({
    //   where: {
    //     ...state.searchValues,
    //     packageStations_some: {
    //       isActive: state.dropPointIsActive ? undefined : false,
    //       isOnboarded: true,
    //     },
    //   },
    // });
    dispatch({ type: 'SET_INACTIVE_DROPPOINT', value: true });
  };
  const handleHideInactiveDropPoints = async () => {
    // await refetch({
    //   where: {
    //     ...state.searchValues,
    //     packageStations_some: {
    //       isActive: state.dropPointIsActive ? true : undefined,
    //     },
    //   },
    // });
    dispatch({ type: 'SET_INACTIVE_DROPPOINT', value: false });
  };

  return (
    <Button
      leftIcon={state.inactiveDropPointIsActive ? <X /> : <House />}
      onClick={state.inactiveDropPointIsActive ? handleHideInactiveDropPoints : handleShowInactiveDropPoints}
      size="sm"
      mb="2"
      mr="2"
    >
      Inaktiv
    </Button>
  );
};

export default InactiveDropPointButton;
